import {
  JupiterTheme,
  JupiterOneGradientIcon,
} from '@jupiterone/jupiter-web-toolkit';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    logo: {
      borderRadius: '50%',
    },
  })
);

interface AccountLogoProps {
  size: number | string;
}

const AccountLogo = ({ size }: AccountLogoProps) => {
  const classes = useStyles();

  // TODO: Load company logo once we allow that
  return <JupiterOneGradientIcon className={classes.logo} size={size} />;
};
export default AccountLogo;
